(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["squad-home-nav-featured"] && !Shopify.designMode) return;
  try {
    
  const squadHomeBlock = document.getElementById('squad-home-nav-featured');
  const primaryNavigation = squadHomeBlock?.querySelector('#squad-primary-navigation');
  const secondaryNavigation = squadHomeBlock?.querySelector('#squad-secondary-navigation');
  const featuredHeadline = document.getElementById('squad-featured-headline');
  const gradedHeadline = document.getElementById('squad-graded-headline');
  const sealedHeadline = document.getElementById('squad-sealed-headline');
  const faqHeadline = document.getElementById('squad-faq-headline');

  if (squadHomeBlock) {
    const placeHeadline = (headline, targetSelector) => {
      const target = document.querySelector(targetSelector);

      if (!headline || !target) return;

      const firstPageFlyRow = target.querySelector(':scope > [data-pf-type="Row"]');

      if (headline.parentElement !== target || headline.nextElementSibling !== firstPageFlyRow) {
        target.insertBefore(headline, firstPageFlyRow);
      }

      headline.hidden = false;
    };

    const placeAfterRows = (element, targetSelector) => {
      const target = document.querySelector(targetSelector);

      if (!element || !target) return;

      const pageFlyRows = [...target.querySelectorAll(':scope > [data-pf-type="Row"]')].filter((row) => row !== element);
      const lastPageFlyRow = pageFlyRows.at(-1);

      if (!lastPageFlyRow) return;

      if (element.parentElement !== target || lastPageFlyRow.nextElementSibling !== element) {
        target.insertBefore(element, lastPageFlyRow.nextElementSibling);
      }

      element.hidden = false;
      element.removeAttribute('aria-hidden');
    };

    const placeSquadHeadlines = () => {
      const oldNavigation = document.querySelector('[data-section-id="pf-fc2b"] > div > [data-pf-type="Row"]:first-child');
      const secondaryNavigationSource = document.querySelector('[data-section-id="pf-91af"]');

      if (oldNavigation) {
        oldNavigation.hidden = true;
        oldNavigation.setAttribute('aria-hidden', 'true');
      }

      if (secondaryNavigationSource) {
        secondaryNavigationSource.hidden = true;
        secondaryNavigationSource.setAttribute('aria-hidden', 'true');
      }

      placeHeadline(featuredHeadline, '[data-section-id="pf-9884"] > div');
      placeAfterRows(primaryNavigation, '[data-section-id="pf-9884"] > div');
      placeHeadline(gradedHeadline, '[data-section-id="pf-5199"] > div');
      placeAfterRows(secondaryNavigation, '[data-section-id="pf-5199"] > div');
      placeHeadline(sealedHeadline, '[data-section-id="pf-5fee"] > div');
      placeHeadline(faqHeadline, '[data-section-id="pf-06a5"] > div');
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', placeSquadHeadlines, { once: true });
    } else {
      placeSquadHeadlines();
    }

    let placementAttempts = 0;
    const placementTimer = window.setInterval(() => {
      placeSquadHeadlines();
      placementAttempts += 1;

      if (placementAttempts >= 40) {
        window.clearInterval(placementTimer);
      }
    }, 250);
  }

  } catch(e) { console.error(e); }
})();
})();
